
import { Component, Prop, Vue } from 'bits/vue'
import OzOverlay from 'library/v4/components/OzOverlay.vue'

/**
 * Mobile Static Drawer Modal
 */

@Component({ components: { OzOverlay } })
export default class OzDrawerStatic extends Vue {
  $refs!: {
    modalContainer: HTMLDivElement
  }

  /**
   * To force full size drawer
   */
  @Prop({ default: false }) fullSize!: boolean

  /**
   * Set dark mode
   */
  @Prop({ default: 'auto' }) darkMode!: true | false | 'auto'

  /**
   * Show a scrim.
   */
  @Prop({ default: true }) xScrim!: boolean

  /**
   * Decides if scrim is not really there and can be clicked through
   **/
  @Prop({ default: false }) isScrimSpectral!: boolean

  /**
   * Determines whether the modal should fade in when opened
   */
  @Prop({ default: true }) shouldFadeIn!: boolean

  /**
   *  TailwindCSS z-index class.
   *
   *  - `z-modal2` is for all dialogs
   *  - `z-sidepanel` is for surface sidepanels
   */
  @Prop({ required: false }) zIndexClass?: 'z-modal2' | 'z-sidepanel'

  /**
   * Determines whether the scrollbar should be hidden
   */
  @Prop({ required: false }) hideScrollbar?: boolean

  /**
   * Determines whether the modal should slide up/down when enter/leave screen
   */
  @Prop({ default: true }) shouldAnimateOnAppear!: boolean

  scrimClick(): void {
    /**
     * Emitted with overlay scrim is clicked. Can be used to trigger closure of drawer.
     */
    this.$emit('scrim-click')
  }

  scrimEsc(): void {
    /**
     * Emitted when Escape key is pressed. Can be used to trigger closure of drawer.
     */
    this.$emit('scrim-esc')
  }

  isTouchingTopOfScreen = false
  mounted(): void {
    if (this.fullSize) {
      this.isTouchingTopOfScreen = true
    }
    if (this.$refs.modalContainer.clientHeight >= this.$el.clientHeight) {
      this.isTouchingTopOfScreen = true
    }
  }
}
